/**
 * 指令和插件加载
 */

import type { Plugin } from 'vue';
// plugins

// todo 把主站的插件都放在这里来

export default [] as Plugin[];
